import * as React from 'react';
import { LightboxState } from '../use-lightbox-reducer';
import { LightboxStateContext } from './lightbox-state.context';

export function useLightboxState(): LightboxState {
    return React.useContext(LightboxStateContext);
}
